import { gql } from '@apollo/client'

import { FRAGMENT as ARTICLE_FRAGMENT } from '../../components/LibraryPostArticleCard'
import { FRAGMENT as VIDEO_FRAGMENT } from '../../components/LibraryPostVideoCard'

export const PAGES = gql`
  query SeriesPages {
    libraryCollections(perPage: 100) {
      nodes {
        id
        slug
      }
    }
  }
`

export const COLLECTION = gql`
  query Collection($slug: String!) {
    libraryCollection(slug: $slug) {
      id
      title
      description
      slug
      color
      type
      posts {
        nodes {
          ... on LibraryPostArticle {
            ...LibraryPostArticleCardComponent
          }
          ... on LibraryPostVideo {
            ...LibraryPostVideoCardComponent
          }
        }
      }
    }
  }

  ${VIDEO_FRAGMENT}
  ${ARTICLE_FRAGMENT}
`
